import {DatePicker} from "react-advance-jalaali-datepicker";
import Icon from "./Icon";
import React from "react";

function DateField({label, icon, value, onChange}) {
    value = value ? value : "";
    icon = icon ? icon : "calendar-days";

    let inputref = React.createRef();
    let labelref = React.createRef();
    let labelbodyref = React.createRef();


    let labelStyle = {}

    let labelBodyStyle = {}

    if (value.toString().trim() !== "") {
        labelStyle = {
            marginTop: "-10px",
        }
        labelBodyStyle = {
            backgroundColor: "#ffffff",
            cursor: "pointer",
            color: "#313131"
        }
    }

    return (
        <div className="form-control-text form-control-date">
            {label ?
                <div className="label"
                     ref={labelref}
                     style={labelStyle}
                     onClick={() => {
                         try {
                             inputref.current.focus();
                         } catch (err) {
                         }
                     }
                     }>

                    <div className="label-body"
                         style={labelBodyStyle}
                         ref={labelbodyref}>
                        {icon ? <Icon i={icon}/> : null}
                        <span className="title">{label}</span>
                    </div>
                </div> : null
            }
            <DatePicker
                controlValue={true}
                id="date"
                preSelected={value ? value : ""}
                inputComponent={
                    (props) =>
                        <DatePickerInput {...props}
                                         value={value}
                                         labelref={labelref}
                                         labelbodyref={labelbodyref}
                                         inputref={inputref}/>}
                placeholder=""
                inputTextAlign={"center"}
                format="jYYYY/jMM/jDD"
                onChange={(unix, formatted) => {
                    if (onChange) {
                        onChange(unix, formatted);
                    }
                }
                }
            />
        </div>
    )
}

function DatePickerInput(props) {

    const {labelref, labelbodyref, inputref, value} = props;
    return <input className="input-date" {...props}
                  onFocus={() => {
                      labelref.current.style.marginTop = "-10px";
                      labelbodyref.current.style.backgroundColor = "#ffffff";
                      labelbodyref.current.style.cursor = "pointer";
                      labelbodyref.current.style.color = "#313131";
                  }
                  }
                  onBlur={() => {
                      if (value.toString().trim() === "") {
                          labelref.current.style.marginTop = "8px";
                          labelbodyref.current.style.backgroundColor = "rgba(0, 0, 0, 0)";
                          labelbodyref.current.style.cursor = "text";
                          labelbodyref.current.style.color = "#656565";
                      }
                  }
                  }
                  ref={inputref}/>;
}

export default DateField;